import type * as React from 'react';

import { PageSplit, PageSplitAside, PageSplitBody, PageSplitMain } from '@gitbook/spine-react';

import { WireframedSiteAsset } from '../../Components/Onboarding';
import { ChurroAsideBg } from '../../Components/Onboarding/ChurroAsideBg';

// Screen shown when creating a new organization
export function WelcomeLayout(props: {
    children: React.ReactNode;
    title?: string;
}): React.ReactElement {
    return (
        <div className="flex flex-1">
            <PageSplit>
                <PageSplitMain>
                    <PageSplitBody size="medium">{props.children}</PageSplitBody>
                </PageSplitMain>
                <PageSplitAside className="overflow-visible" customGradient={<ChurroAsideBg />}>
                    <WireframedSiteAsset
                        siteName={props.title ? `${props.title} Docs` : undefined}
                    />
                </PageSplitAside>
            </PageSplit>
        </div>
    );
}
